import { Card, CardContent, CardHeader, CardTitle } from "../ui/card";
import { TestSubsection } from "./TestSection";
import { Clock, Zap, Database, Shield } from "lucide-react";
import * as tests from "./testDefinitions";

export const RealtimeAvailabilitySection = ({ testResults }) => {
  return (
    <Card>
      <CardHeader>
        <CardTitle className="text-lg font-semibold">Real-Time Availability</CardTitle>
      </CardHeader>
      <CardContent className="space-y-6">
        <TestSubsection
          icon={Zap}
          iconColor="text-yellow-600"
          title="Availability System"
          tests={tests.realtimeAvailabilityTests}
          results={testResults.realtimeAvailability}
        />
      </CardContent>
    </Card>
  );
};
